import { render, staticRenderFns } from "./law-cases.vue?vue&type=template&id=7aa3c3a4"
import script from "./law-cases.vue?vue&type=script&lang=js"
export * from "./law-cases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports